module.exports = __webpack_public_path__ + "static/media/CRA.c48699ed.png";